import { ReactNode } from 'react';

import {
  ChoiceCardBox,
  ChoiceCardIcon,
  ChoiceCardContent,
  ChoiceCardTitleRow,
  ChoiceCardTitle,
  ChoiceCardBadge,
  ChoiceCardDesc,
  ChoiceCardRadio,
} from './styled';

interface ChoiceCardProps {
  icon: ReactNode;
  title: ReactNode;
  desc?: ReactNode;
  badge?: ReactNode;
  selected: boolean;
  onClick: () => void;
  dataTestId?: string;
}

const ChoiceCard = ({
  icon,
  title,
  desc,
  badge,
  selected,
  onClick,
  dataTestId,
}: ChoiceCardProps) => (
  <ChoiceCardBox
    $selected={selected}
    onClick={onClick}
    role="button"
    data-testid={dataTestId}
  >
    <ChoiceCardIcon>{icon}</ChoiceCardIcon>
    <ChoiceCardContent>
      <ChoiceCardTitleRow>
        <ChoiceCardTitle $selected={selected}>{title}</ChoiceCardTitle>
        {badge && <ChoiceCardBadge>{badge}</ChoiceCardBadge>}
      </ChoiceCardTitleRow>
      {desc && <ChoiceCardDesc>{desc}</ChoiceCardDesc>}
    </ChoiceCardContent>
    <ChoiceCardRadio $selected={selected} />
  </ChoiceCardBox>
);

export default ChoiceCard;
